import type { SVGProps } from 'react';
const DawnFlagGA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-GA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-GA_svg__a)">
      <path fill="#09B470" d="M0 5.333h22V0H0z" />
      <path fill="#508CDE" d="M0 16h22v-5.333H0z" />
      <path fill="#FFD935" d="M0 10.667h22V5.333H0z" />
    </g>
  </svg>
);
export default DawnFlagGA;
